import React from 'react';
import {useParams} from 'react-router-dom';
import SestManagementSettingBottomSheet from '@di-shared/features/diag/sest/SestManagementSettingBottomSheet';

function SestManagementSettingBottomSheetPage() {
  const {sestCode} = useParams();
  const vin = window.data.vin as unknown as string;
  const replaceDate = window.data.replaceDate as unknown as Date | null | undefined;
  const replaceOdometer = window.data.replaceOdometer as unknown as number | undefined;
  const isServiceCenterInput = window.data.isServiceCenterInput as unknown as boolean | undefined;
  const historyId = window.data.historyId as unknown as string;

  if (!sestCode) {
    window.bottomSheetClose(null);
    return null;
  }
  return (
    <SestManagementSettingBottomSheet
      sestCode={sestCode}
      vin={vin}
      isServiceCenterInput={isServiceCenterInput}
      replaceDate={replaceDate}
      replaceOdometer={replaceOdometer}
      historyId={historyId}
    />
  );
}

export default SestManagementSettingBottomSheetPage;
